import {
  GETWALLETOWNERLIST_SUCCESS,
  GETWALLETOWNERLIST_FAILED,
  RESET_GETWALLETOWNERLIST,
  LOADING_GETWALLETOWNERLIST,
  NETWORK_ERROR_GETWALLETOWNERLIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetWalletOwnerList = () => {
  return { type: RESET_GETWALLETOWNERLIST };
};

const getWalletOwnerList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETWALLETOWNERLIST });
  await adminServices
    .post("getWalletOwnerList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getWalletOwnerListsuccess(res.data));
          break;
        default:
          dispatch(getWalletOwnerListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETWALLETOWNERLIST, payload: err });
    });
};
function getWalletOwnerListsuccess(data) {
  return {
    type: GETWALLETOWNERLIST_SUCCESS,
    payload: data,
  };
}
function getWalletOwnerListFailed(data) {
  return {
    type: GETWALLETOWNERLIST_FAILED,
    payload: data,
  };
}

export { resetGetWalletOwnerList, getWalletOwnerList };
